type PurchaserGraphQLMutationResult = {
  data?: unknown;
  error?: Error;
  errors?: readonly { message: string }[];
};

export const PURCHASER_GRAPHQL_MUTATION_OPTIONS = {
  fetchPolicy: "no-cache" as const,
  errorPolicy: "all" as const,
};

function getPurchaserGraphQLMutationErrorMessage(
  result: PurchaserGraphQLMutationResult,
): string | null {
  if (result.error instanceof Error && result.error.message.trim()) {
    return result.error.message.trim();
  }

  const messages = result.errors
    ?.map((entry) => entry.message)
    .filter(Boolean)
    .join(", ");

  return messages?.trim() || null;
}

export function requirePurchaserGraphQLMutationPayload<TPayload>(
  result: PurchaserGraphQLMutationResult,
  payload: TPayload | null | undefined,
  fallbackMessage: string,
): TPayload {
  if (payload != null) {
    return payload;
  }

  throw new Error(
    getPurchaserGraphQLMutationErrorMessage(result) ?? fallbackMessage,
  );
}
